import { render, staticRenderFns } from "./CustomerStatTab.vue?vue&type=template&id=61cc510b&scoped=true&"
import script from "./CustomerStatTab.vue?vue&type=script&lang=js&"
export * from "./CustomerStatTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStatTab.vue?vue&type=style&index=0&id=61cc510b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cc510b",
  null
  
)

export default component.exports